// The installable app (docs/crm/mobile.md): registers the service worker
// (/service-worker.js) and empties the pages it stored when the session ends —
// on submitting the sign-out form (data-pwa-clear) and on any signed-out
// screen (body[data-pwa-signed-out]: the sign-in and 2FA pages), which also
// covers a session that simply expired. The sign-out response's
// Clear-Site-Data header does the same in browsers that support it.
const PAGE_CACHE = "lcrm-pages"

function clearPages() {
  if (navigator.serviceWorker && navigator.serviceWorker.controller) {
    navigator.serviceWorker.controller.postMessage("clear")
  }
  if (window.caches) window.caches.delete(PAGE_CACHE).catch(() => {})
}

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js", { scope: "/" }).catch(() => {})
  })
}

document.addEventListener("submit", (event) => {
  if (event.target.closest("form[data-pwa-clear]")) clearPages()
})

document.addEventListener("turbo:load", () => {
  if (document.body.hasAttribute("data-pwa-signed-out")) clearPages()
})
